import { z } from "zod";
import { EmailSchema, IdSchema, IsoDateTimeSchema, PersonNameSchema } from "../common/primitives.js";
import { GrantablePermissionSchema, RoleSchema } from "../auth/permissions.js";
export const USER_STATUSES = ["active", "deactivated"];
export const UserStatusSchema = z.enum(USER_STATUSES);
export const UserSummarySchema = z.object({
    id: IdSchema,
    name: PersonNameSchema,
    email: EmailSchema,
    role: RoleSchema,
    status: UserStatusSchema,
    mustChangePassword: z.boolean(),
    /** "Must ask admin before buying" (D-47): off by default; never on for admins. */
    requiresPurchaseApproval: z.boolean(),
    extraPermissions: z.array(GrantablePermissionSchema),
    createdAt: IsoDateTimeSchema,
});
/** GET /api/v1/users */
export const UserListResponseSchema = z.object({
    data: z.array(UserSummarySchema),
});
/** POST /api/v1/users — the admin creates the account; the person must change the temporary password at first sign-in. */
export const CreateUserRequestSchema = z.object({
    name: PersonNameSchema,
    email: EmailSchema,
    role: RoleSchema.default("employee"),
});
export const CreateUserResponseSchema = z.object({
    user: UserSummarySchema,
    /** Shown to the admin exactly once. Never stored in plain text or logged. */
    temporaryPassword: z.string(),
});
/** PATCH /api/v1/users/:id */
export const UpdateUserRequestSchema = z
    .object({
    name: PersonNameSchema.optional(),
    role: RoleSchema.optional(),
    requiresPurchaseApproval: z.boolean().optional(),
})
    .refine((v) => v.name !== undefined || v.role !== undefined || v.requiresPurchaseApproval !== undefined, {
    message: "Provide at least one field to change",
});
/** PUT /api/v1/users/:id/permissions — replaces the person's extra permissions. */
export const SetPermissionsRequestSchema = z.object({
    permissions: z
        .array(GrantablePermissionSchema)
        .max(20)
        .refine((list) => new Set(list).size === list.length, { message: "Permissions must not repeat" }),
});
/** Response for single-user operations. */
export const UserResponseSchema = z.object({ user: UserSummarySchema });
//# sourceMappingURL=users.js.map